import { useEffect, useState } from 'react';

import { Translate } from '@spazious/dollhouse-i18n';
import { Flex, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { DollhouseMessage, MainViewMessage } from '../../core/EventManager.js';
import { ConfirmDialog } from '../ConfirmDialog/index.js';
import { useEvents } from '../EventManager/index.js';

const ResetMetadataConfirmationForm = ({ count }: { count: number }) => {
  const countText = count === 1 ? 'furniture is' : 'furnitures are';

  return (
    <Flex gap="var(--spacing-gap)">
      <Typography variant="title">
        <Translate>Currently </Translate> {count} {countText}{' '}
        <Translate>hidden and these changes will reset the values</Translate>
      </Typography>
    </Flex>
  );
};

export const ResetMetadataDialog: React.FC = () => {
  const events = useEvents();
  const [resetConfirmDialogOpen, setResetConfirmDialogOpen] = useState(false);
  const [furnitureCount, setFurnitureCount] = useState(0);

  const handleClose = useEventCallback(() => {
    setResetConfirmDialogOpen(false);
  });
  const doReset = useEventCallback(() => {
    setResetConfirmDialogOpen(false);
    events.emit('mainViewMessage', MainViewMessage.InvisibleNodesResetConfirm);
  });

  useEffect(() => {
    const cb: (message: DollhouseMessage, data: string | number | undefined) => void = (
      message: DollhouseMessage,
      data: string | number | undefined
    ) => {
      if (message === DollhouseMessage.GetDeletionsCount) {
        setFurnitureCount(data as number);
      }
    };
    events.on('dollhouseMessage', cb);
    return () => {
      events.off('dollhouseMessage', cb);
    };
  }, [events]);

  useEffect(() => {
    const cb = (message: DollhouseMessage) => {
      if (message === DollhouseMessage.ConfirmInvisibleNodesReset) {
        setResetConfirmDialogOpen(true);
      }
    };
    events.on('dollhouseMessage', cb);
    return () => {
      events.off('dollhouseMessage', cb);
    };
  }, [events]);
  return (
    <ConfirmDialog
      fullWidth
      content={<ResetMetadataConfirmationForm count={furnitureCount} />}
      maxWidth="600px"
      open={resetConfirmDialogOpen}
      onClose={handleClose}
      onConfirm={doReset}
    />
  );
};
